/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../../../../_metronic/_helpers";
import SyncIcon from "@material-ui/icons/Sync";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";

export const ActionsColumnFormatter = (
  cellContent,
  row,
  rowIndex,
  {
    openDetailKurbanListPage,
    openMergingDetail = () => {},
    openKurbanDetail = () => {},
  }
) => (
  <>
    <OverlayTrigger
      overlay={<Tooltip id="detail-trx-tooltip">Detail Donasi</Tooltip>}
    >
      <a
        className="btn btn-icon btn-light btn-hover-primary btn-sm mx-2"
        onClick={() => openDetailKurbanListPage(row.donation_uuid)}
      >
        <span className="svg-icon svg-icon-md svg-icon-primary">
          <SVG
            src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
          />
        </span>
      </a>
    </OverlayTrigger>
    {!row.thk_kurban_uuid ? (
      <OverlayTrigger
        overlay={<Tooltip id="detail-trx-tooltip">Ubah Hewan</Tooltip>}
      >
        <a
          className="btn btn-icon btn-light btn-hover-success btn-sm mx-2"
          onClick={() => openMergingDetail(row.uuid)}
        >
          <span className="svg-icon svg-icon-md svg-icon-success">
            <SyncIcon />
          </span>
        </a>
      </OverlayTrigger>
    ) : (
      <OverlayTrigger
        overlay={<Tooltip id="detail-trx-tooltip">Laporan Kurban</Tooltip>}
      >
        <a
          className="btn btn-icon btn-light btn-sm mx-2"
          onClick={() => openKurbanDetail(row.thk_kurban.uuid)}
        >
          {/* <span className="svg-icon svg-icon-md"> */}
          <LocalOfferIcon style={{ color: "#FFA800" }} />
          {/* </span> */}
        </a>
      </OverlayTrigger>
    )}
  </>
);
